import { render, staticRenderFns } from "./SmsTemplateDetail.vue?vue&type=template&id=f7d63030&scoped=true&"
import script from "./SmsTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d63030",
  null
  
)

export default component.exports